(function () {
  const section = document.querySelector('.vc-campaign-artefacts');
  if (!section) return;

  const trackWrap   = section.querySelector('.vc-campaign-artefacts__track-wrap');
  const track       = section.querySelector('.vc-campaign-artefacts__track');
  const cards       = Array.from(section.querySelectorAll('.vc-campaign-artefacts__card'));
  const progressEl  = section.querySelector('.vc-campaign-artefacts__progress');
  const progressBar = section.querySelector('.vc-campaign-artefacts__progress-bar');
  const prevBtn     = section.querySelector('.vc-campaign-artefacts__nav-btn--prev');
  const nextBtn     = section.querySelector('.vc-campaign-artefacts__nav-btn--next');

  if (!track || !cards.length) return;

  const EASE       = 'cubic-bezier(0.7, 0.1, 0.3, 1)';
  const DUR_BASE   = 0.45;

  let currentIndex = 0;

  /* ── Responsive helpers ── */
  function getGap() {
    return parseInt(getComputedStyle(track).gap) || 2;
  }

  function getCardWidth() {
    return cards[0].offsetWidth;
  }

  function getVisibleCount() {
    const gap = getGap();
    return Math.floor((trackWrap.offsetWidth + gap) / (getCardWidth() + gap));
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCount());
  }

  function updateScrollState() {
    section.toggleAttribute('data-no-scroll', getMaxIndex() === 0);
  }

  /* Mobile uses the browser's own scroll-snap; the transport mirrors and drives it */
  const nativeMq = window.matchMedia('(max-width: 675px)');

  function setProgress(ratio, animate) {
    if (!progressBar || !progressEl) return;
    const range = progressEl.offsetWidth - progressBar.offsetWidth;
    const barX  = ratio * range;
    if (animate) gsap.to(progressBar, { x: barX, duration: DUR_BASE, ease: EASE });
    else gsap.set(progressBar, { x: barX });
  }

  function setButtons(atStart, atEnd) {
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
  }

  function nativeMaxScroll() {
    return Math.max(0, trackWrap.scrollWidth - trackWrap.clientWidth);
  }

  function syncFromScroll() {
    const max  = nativeMaxScroll();
    const left = trackWrap.scrollLeft;
    currentIndex = Math.round(left / (getCardWidth() + getGap()));
    setProgress(max > 0 ? left / max : 0, false);
    setButtons(left <= 1, left >= max - 1);
  }

  /* ── Navigate to index ── */
  function goTo(index) {
    if (nativeMq.matches) {
      gsap.set(track, { x: 0 });
      const step = getCardWidth() + getGap();
      const max  = Math.max(0, Math.ceil(nativeMaxScroll() / step));
      currentIndex = Math.max(0, Math.min(index, max));
      trackWrap.scrollTo({ left: Math.min(currentIndex * step, nativeMaxScroll()), behavior: 'smooth' });
      return;
    }

    const max = getMaxIndex();
    currentIndex = Math.max(0, Math.min(index, max));

    const cardW  = getCardWidth();
    const gap    = getGap();
    const offset = -(currentIndex * (cardW + gap));

    gsap.to(track, { x: offset, duration: DUR_BASE, ease: EASE });

    if (progressBar && progressEl) {
      const range = progressEl.offsetWidth - progressBar.offsetWidth;
      const barX  = max > 0 ? (currentIndex / max) * range : 0;
      gsap.to(progressBar, { x: barX, duration: DUR_BASE, ease: EASE });
    }

    setButtons(currentIndex <= 0, currentIndex >= max);
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

  trackWrap.addEventListener('scroll', () => {
    if (nativeMq.matches) syncFromScroll();
  }, { passive: true });

  let resizeTimer;
  updateScrollState();
  if (nativeMq.matches) syncFromScroll(); else goTo(0);

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateScrollState();
      if (nativeMq.matches) {
        gsap.set(track, { x: 0 });
        syncFromScroll();
      } else {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        goTo(currentIndex);
      }
    }, 150);
  });

  /* ══════════════════════════════════════════════
     Artefact modal
  ══════════════════════════════════════════════ */
  var modal = document.getElementById('vc-modal-artefact');
  if (!modal) return;

  /* Teleport to <body> so position:fixed escapes ScrollSmoother's transform */
  document.body.appendChild(modal);

  var panel     = modal.querySelector('.vc-modal-artefact__panel');
  var overlay   = modal.querySelector('.vc-modal-artefact__overlay');
  var titleEl   = modal.querySelector('[data-vc-artefact-title]');
  var subtitleEl= modal.querySelector('[data-vc-artefact-subtitle]');
  var numberEl  = modal.querySelector('[data-vc-artefact-number]');
  var numberWrap= modal.querySelector('[data-vc-artefact-number-wrap]');
  var yearEl    = modal.querySelector('[data-vc-artefact-year]');
  var yearWrap  = modal.querySelector('[data-vc-artefact-year-wrap]');
  var imageWrap = modal.querySelector('[data-vc-artefact-image-wrap]');
  var bodyEl    = modal.querySelector('[data-vc-artefact-body]');
  var closeBtns = modal.querySelectorAll('[data-vc-artefact-close]');

  var contentEl  = modal.querySelector('.vc-modal-artefact__content');
  var scrollHint = modal.querySelector('[data-vc-artefact-scroll-hint]');
  var HINT_SCROLL_THRESHOLD = 8;

  /* Visible only while the content overflows and is still at the top */
  function updateScrollHint() {
    if (!scrollHint || !contentEl) return;
    var overflows = contentEl.scrollHeight > contentEl.clientHeight + 1;
    var atTop     = contentEl.scrollTop <= HINT_SCROLL_THRESHOLD;
    scrollHint.classList.toggle('is-hidden', !(overflows && atTop));
  }

  if (scrollHint && contentEl) {
    contentEl.addEventListener('scroll', updateScrollHint, { passive: true });
    window.addEventListener('resize', updateScrollHint);
  }

  var tl = null;

  function buildTimeline() {
    var isMobile = window.matchMedia('(max-width: 675px)').matches;
    /* Mobile: slide up from fully off-screen (bottom sheet).
       Desktop: subtle upward reveal from 20px below centre. */
    return gsap.timeline({ paused: true, defaults: { ease: EASE } })
      .fromTo(overlay,
        { opacity: 0 },
        { opacity: 1, duration: 0.35 },
        0
      )
      .fromTo(panel,
        { opacity: 0, y: isMobile ? '100vh' : 20 },
        { opacity: 1, y: 0, duration: isMobile ? 0.55 : 0.45 },
        0
      );
  }

  function openModal(data) {
    /* Populate */
    titleEl.textContent    = data.title    || '';
    subtitleEl.textContent = data.subtitle || '';
    numberEl.textContent   = data.number   || '';
    yearEl.textContent     = data.year     || '';
    numberWrap.hidden      = !data.number;
    yearWrap.hidden        = !data.year;
    bodyEl.innerHTML       = '';

    if (data.body) {
      data.body.split('\n').filter(Boolean).forEach(function (para) {
        var p = document.createElement('p');
        p.textContent = para;
        bodyEl.appendChild(p);
      });
    }

    imageWrap.innerHTML = '';
    if (data.img) {
      var img = document.createElement('img');
      img.src = data.img;
      img.alt = data.title || '';
      img.className = 'vc-modal-artefact__img';
      img.loading = 'lazy';
      /* Image height changes the overflow, so re-evaluate once it has loaded */
      img.addEventListener('load', updateScrollHint);
      imageWrap.appendChild(img);
    }

    /* Content scroll reset */
    var content = modal.querySelector('.vc-modal-artefact__content');
    if (content) content.scrollTop = 0;
    updateScrollHint();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    /* Rebuild each open so mobile/desktop detection is always fresh */
    if (tl) tl.kill();
    tl = buildTimeline();
    tl.play();
  }

  function closeModal() {
    if (!tl) return;
    tl.reverse().then(function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }

  /* ── Card click ── */
  cards.forEach(function (card) {
    function handleOpen() {
      openModal({
        title:    card.dataset.modalTitle    || '',
        subtitle: card.dataset.modalSubtitle || '',
        number:   card.dataset.modalNumber   || '',
        year:     card.dataset.modalYear     || '',
        img:      card.dataset.modalImg      || '',
        body:     card.dataset.modalBody     || '',
      });
    }

    card.addEventListener('click', handleOpen);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen(); }
    });
  });

  /* ── Close ── */
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  /* ── Focus trap ── */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusables = Array.from(panel.querySelectorAll(
      'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])'
    ));
    if (!focusables.length) return;
    var first = focusables[0];
    var last  = focusables[focusables.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

})();
